<template>
  <div class="records-search-wrapper">
    <el-form
      ref="searchform"
      :inline="true"
      :model="searchFormData"
      @submit.native.prevent
    >
      <el-form-item
        v-for="item in searchOptions"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
      >
        <template v-if="item.type === 'input'">
          <el-input
            :style="{ width: item.width || '100%' }"
            v-model="searchFormData[item.prop]"
            @blur="blur(item)"
            :placeholder="item.placeholder || '请输入'"
          ></el-input>
        </template>
        <template v-if="item.type === 'select'">
          <el-select
            :style="{ width: item.width || '100%' }"
            v-model="searchFormData[item.prop]"
            :placeholder="item.placeholder || '请选择'"
          >
            <el-option
              v-for="option in item.data"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            ></el-option>
          </el-select>
        </template>
        <template v-if="item.type === 'autocomplete'">
          <el-autocomplete
            :style="{ width: item.width || '100%' }"
            clearable
            v-model="searchFormData[item.prop]"
            :fetch-suggestions="item.querySearchAsync"
            :placeholder="item.placeholder || '请输入'"
          >
          </el-autocomplete>
        </template>
      </el-form-item>
      <el-form-item>
        <el-button class="btn1" type="primary" @click="onSearch"
          >查询</el-button
        >
        <el-button class="btn2" @click="clearAll">重置</el-button>
        <el-button
          v-if="isExport"
          :disabled="isExportShow"
          class="btn2"
          @click="onExport"
          >导出</el-button
        >
      </el-form-item>
      <slot></slot>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "DirectRecordSearch",
  props: {
    // 搜索数据
    searchData: {
      type: Object,
      default: () => {},
    },
    // 搜索配置项
    searchOptions: {
      type: Array,
      default: () => [],
    },
    // 其他配置项
    options: {
      type: Object,
      default: () => {},
    },
    // 是否显示导出按钮
    isExport: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isExportShow() {
      let b = true;
      if (
        this.searchFormData.bankNo ||
        this.searchFormData.bankName ||
        this.searchFormData.acceptBankLevelType
      ) {
        b = false;
      }
      return b;
    },
  },
  data() {
    return {
      searchFormData: this.searchData || {},
    };
  },
  methods: {
    onSearch() {
      this.$emit("onSearch", this.searchFormData);
    },
    clearAll() {
      this.searchFormData = {};
      this.$emit("onSearch", this.searchFormData);
    },
    onExport() {
      this.$emit("onExport", this.searchFormData);
    },
    blur(item) {
      if (!item.blur) return
      if (this.searchFormData[item.prop] && !/(^[1-9]\d*$)/.test(this.searchFormData[item.prop])) {
        this.searchFormData[item.prop] = ''
        this.$message.warning('请输入正整数')
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.records-search-wrapper {
    margin-bottom: 8px;
    ::v-deep.el-form-item {
        margin: 0 8px 0 0;
        
        .el-form-item__label, .el-form-item__content {
            line-height: 30px;
        }
        .el-select .el-input .el-select__caret {
            line-height: 30px;
            // color: $greyColor;
        }
        .el-form-item__label {
            font-size: 14px;
            // color: $mainTextColor;
            font-weight: 400;
            padding-right: 10px;
        }
        .el-input__inner {
            height: 30px;
            // border-color: $inputNormal;
            border-radius: 2px;
            &:hover, &:focus {
              //  border-color: $mainColor;
            }
        }
    }
    .el-button + .el-button {
        margin-left: 8px;
    }
    .btn1, .btn2 {
        padding: 0 16px;
        line-height: 30px;
        border-radius: 2px;
        font-size: 14px;
        font-weight: 500;
    }
    .btn1 {
        // background: $mainColor;
        border: none;
        // &:hover {
        //     background: $btnHover;
        // }
        // &:active {
        //     background: $btnClick;
        // }
    }
    .btn2 {
        // border-color: $mainColor;
        // color: $mainColor;
        line-height: 28px;
        background: #fff;
        &:hover {
            // border-color: $btnHover;
            // color: $btnHover;
            background: #fff;
        }
        &:active {
            // border-color: $btnClick;
            // color: $btnClick;
        }
    }
}
</style>
